import { render, staticRenderFns } from "./RemotePages.vue?vue&type=template&id=a6ff3c8a&"
import script from "./RemotePages.vue?vue&type=script&lang=js&"
export * from "./RemotePages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports